const storageKey = (userId) => `inspectionMapView_${userId}`;

// sessionStorage, unlike the filters: a new tab starts by fitting its pins instead of
// reopening wherever another tab was left.
export function loadView(userId) {
    try {
        const {center, zoom} = JSON.parse(sessionStorage.getItem(storageKey(userId))) || {};
        const valid = Array.isArray(center) && center.length === 2 && center.every(Number.isFinite) && Number.isFinite(zoom);
        return valid ? {center, zoom} : null;
    } catch(e) {
        return null;
    }
}

export function saveView(userId, view) {
    try {
        sessionStorage.setItem(storageKey(userId), JSON.stringify(view));
    } catch(e) {
        // Storage can be full or blocked; the map just won't come back to the same spot.
    }
}
